module.exports = __webpack_public_path__ + "static/img/banner.f854d403.png";